import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f76cbc5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-add-popover" }

import { computed, PropType, ref } from 'vue';
import { PopoverPositionEnum, TirPmPopover } from 'tir-components';
import { PopoverOptionList, PopoverOptionLi } from '../popover-option-list';
import { FolderIcon, ListBulletIcon } from 'tir-style-system/icons/outline';
import SidebarAddPopoverFolderForm from '../sidebar-add-popover-folder-form.vue';
import SidebarAddPopoverQueueForm from '../sidebar-add-popover-queue-form.vue';
import { TreeItemType } from '../../enums';
import { GroupModel, QueueTasksModel } from '../../models';
import { FormCreateQueue } from '@/components/form-create-queue';


export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar-add-popover',
  props: {
  /**Локация */
  location: {
    type: String as PropType<TreeItemType>,
    required: true,
  },
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  /**ID родительской группы */
  parentGroupId: {
    type: Number,
  },
  position: {
    type: String as PropType<PopoverPositionEnum>,
    default: PopoverPositionEnum.Auto,
  },
},
  emits: ["onCreateGroup", "onCreateQueue", "toggleVisible"],
  setup(__props, { emit }) {





/**Ссылка на компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

/**Видимость формы создания папки */
const viewFolderForm = ref(false);
/**Видимость формы создания очереди */
const viewQueueForm = ref(false);

/**Ширина поповера */
const width = computed(() => {
  if (viewFolderForm.value || viewQueueForm.value) return '25rem';
  return '17.5rem';
});

/**
 * * При открытии поповера
 */
const onOpenPopover = () => {
  emit('toggleVisible', true);
};

/**
 * * При закрытии поповера
 */
const onClosePopover = () => {
  viewFolderForm.value = false;
  viewQueueForm.value = false;
  emit('toggleVisible', false);
};

/**
 * * При создании группы
 * @param group Группа
 */
const onCreateGroup = (group: GroupModel) => {
  emit('onCreateGroup', group);
  $popover.value?.close();
};

/**
 * * При создании очереди задач
 * @param queue Очередь задач
 */
const onCreateQueue = (queue: QueueTasksModel) => {
  emit('onCreateQueue', queue);
  $popover.value?.close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmPopover), {
      ref_key: "$popover",
      ref: $popover,
      position: __props.position,
      width: width.value,
      onClose: onClosePopover,
      onOpen: onOpenPopover
    }, {
      content: _withCtx(() => [
        (viewFolderForm.value)
          ? (_openBlock(), _createBlock(SidebarAddPopoverFolderForm, {
              key: 0,
              "namespace-id": __props.namespaceId,
              "parent-group-id": __props.parentGroupId,
              location: __props.location,
              onOnCreate: onCreateGroup
            }, null, 8, ["namespace-id", "parent-group-id", "location"]))
          : (viewQueueForm.value)
            ? (_openBlock(), _createBlock(_unref(FormCreateQueue), {
                key: 1,
                "group-id": __props.parentGroupId,
                "namespace-id": __props.namespaceId,
                onOnCreate: onCreateQueue
              }, null, 8, ["group-id", "namespace-id"]))
            : (_openBlock(), _createBlock(_unref(PopoverOptionList), { key: 2 }, {
                default: _withCtx(() => [
                  ([_unref(TreeItemType).Namespace, _unref(TreeItemType).Group].includes(__props.location))
                    ? (_openBlock(), _createBlock(_unref(PopoverOptionLi), {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (viewFolderForm.value = true), ["stop"]))
                      }, {
                        "left-icon": _withCtx(() => [
                          _createVNode(_unref(FolderIcon))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить папку ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (__props.location !== _unref(TreeItemType).Queue)
                    ? (_openBlock(), _createBlock(_unref(PopoverOptionLi), {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (viewQueueForm.value = true), ["stop"]))
                      }, {
                        "left-icon": _withCtx(() => [
                          _createVNode(_unref(ListBulletIcon))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить очередь ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "target")
      ]),
      _: 3
    }, 8, ["position", "width"])
  ]))
}
}

})